export class MomError extends Error {
  constructor(public response: Response) {
    super('Authorization error');
  }
}
